import React from 'react'
import { ReactSVG } from 'react-svg'
import LogoSvg from '../../img/sp-logo.svg'
import SPLogo from '../../img/logo-big-text.png'
import cx from 'classnames'
import * as styles from './logo.styl'

export interface Props {
  size: 'full' | 'small'
  className?: string
  classNameRoot?: string
  role?: string
}

export const Logo: React.FC<Props> = ({
  className,
  size = 'full',
  classNameRoot,
  role
}: Props) => {
  return (
    <div className={cx(styles.wrapper, styles[size])}>
      <span className={styles.logoIcon}>
        {size === 'small' && (
          <ReactSVG
            role={role}
            className={cx(styles.logo_sp, className, styles[size])}
            src={LogoSvg}
          />
        )}
        {size === 'full' && (
          <img
            className={cx(styles.logo_sp, className, styles[size])}
            src={SPLogo}
          />
        )}
      </span>
    </div>
  )
}
